import { Box, Tooltip, Typography } from "@mui/material";

const compactNum = (n) => {
  const num = Number(n) || 0;
  if (num >= 10000000) return `${(num / 10000000).toFixed(1)}Cr`;
  if (num >= 100000) return `${(num / 100000).toFixed(1)}L`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}k`;
  return String(Math.round(num));
};

/**
 * Order-book demand vs supply as a single split bar.
 *
 * Shared by all three Holdings renderings so the same fact reads identically whether
 * it's its own grid column (desktop), a 3px strip under the symbol (tablet), or a
 * labelled bar on a card (phone).
 */
export const DepthBar = ({ demand, supply, height = 8, showLabels = false }) => {
  const d = Math.max(0, Number(demand) || 0);
  const s = Math.max(0, Number(supply) || 0);
  const total = d + s;
  const demandPct = total > 0 ? (d / total) * 100 : 50;

  const bar = (
    <Box
      sx={{
        width: "100%",
        height,
        borderRadius: 999,
        overflow: "hidden",
        display: "flex",
        bgcolor: "action.hover",
      }}
    >
      <Box sx={{ width: `${demandPct}%`, bgcolor: "info.main" }} />
      <Box sx={{ width: `${100 - demandPct}%`, bgcolor: "warning.main" }} />
    </Box>
  );

  if (!showLabels) {
    return (
      <Tooltip title={`Demand: ${d} | Supply: ${s}`}>
        <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center" }}>{bar}</Box>
      </Tooltip>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      {bar}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.4 }}>
        <Typography variant="caption" sx={{ fontSize: "0.65rem", color: "info.main", fontWeight: 700 }}>
          D {compactNum(d)}
        </Typography>
        <Typography variant="caption" sx={{ fontSize: "0.65rem", color: "warning.main", fontWeight: 700 }}>
          S {compactNum(s)}
        </Typography>
      </Box>
    </Box>
  );
};

export default DepthBar;
